import script from "./AIChat.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChat.vue?vue&type=script&setup=true&lang=js"

import "./AIChat.vue?vue&type=style&index=0&id=594e22b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594e22b6"]])

export default __exports__